var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-pic"},[_c('img',{attrs:{"src":require("../assets/imgs/404.webp")}}),_c('span',[_vm._v("呀！这个页面走丢了")])])}]

export { render, staticRenderFns }